
<div>
  <div class="title text-primary  bg-white p-4" >
    Mon établissement
  </div>
  <mat-tab-group mat-stretch-tabs="{{false}}"
                 mat-align-tabs="start" color="primary"
                 [selectedIndex]="0"
  >
    <mat-tab label="Général" >
      @if (establishment) {
        <app-mon-etablissement-general
          (refreshData)="refreshData()"
          [establishment]="establishment"></app-mon-etablissement-general>
      } @else {
        <app-loader></app-loader>
      }
    </mat-tab>

    <mat-tab label="Sites et adresses">
      @if (establishment) {
        <app-sites-adresses [establishment]="establishment"></app-sites-adresses>
      } @else {
        <app-loader></app-loader>
      }
    </mat-tab>

    <mat-tab label="Personnes gestionnaires du compte">
      @if (establishment) {
        <app-personnel [establishment]="establishment"></app-personnel>
      } @else {
        <app-loader></app-loader>
      }
    </mat-tab>
    <mat-tab label="Mes services d’affectation">
      @if (establishment) {
        <app-services-affectation [establishment]="establishment"></app-services-affectation>
      } @else {
        <app-loader></app-loader>
      }
    </mat-tab>
  </mat-tab-group>
</div>
